export enum NatImplementor {
  AGRI_DEPT = 'Agriculture Department',
  CLIMATE_DEPT = 'Climate Change Department',
  CIVIL_AVIATION = 'Department of Civil Aviation, Ports and Marine',
  ENERGY_DEPT = 'Department of Energy',
  LAND_TRANS_DEPT = 'Department of Land Transport',
  ENV_DEPT = 'Environment Department',
  LAND_TRANS_AGENCY = 'Land Transport Agency',
  MARITIME_SAFETY = 'Maritime Safety Authority',
  PUB_TRANS_CORP = 'Public Transport Corporation',
  REVEN_COMM = 'Revenue Commission',
  TOUR_BOARD = 'Tourism Board',
  MIN_INV_ENP_IND = 'Minister for Investment, Entrepreneurship and Industry',
  MIN_FORAFF_TOURISM = 'Minister of Foreign Affairs and Tourism',
  MIN_HEALTH = 'Ministry of Health',
  MIN_INTAFF = 'Ministry of Internal Affairs',
  MIN_TRANS = 'Ministry of Transport',
  MIN_LOCGOV_COMMAFF = 'Ministry for Local Government and Community Affairs',
  MIN_AGRI_CLIM_ENV = 'Ministry of Agriculture, Climate Change and Environment',
  MIN_EDU = 'Ministry of Education',
  MIN_EMP_SOAFF = 'Ministry of Employment and Social Affairs',
  MIN_FIN_ECOPLAN_TRD = 'Ministry of Finance, Economic Planning & Trade',
  MIN_FISH = 'Ministry of Fisheries',
  MIN_LAND_HOUSING = 'Ministry of Lands and Housing',
  MIN_YOUTH_SPO_FAM = 'Ministry of Youth, Sports and Family',
  OFF_PRESIDENT = 'Office of the President',
}

export enum IntImplementor {
  AFC = 'AFC',
  AFD = 'AFD',
  AFDB = 'AFDB',
  EBRD = 'EBRD',
  EIB = 'EIB',
  FAO = 'FAO',
  GCF = 'GCF',
  GEF = 'GEF',
  GIZ = 'GIZ',
  IMF = 'IMF',
  IMO = 'IMO',
  IUCN = 'IUCN',
  NEFCO = 'NEFCO',
  UNWO = 'UN Women',
  UNDP = 'UNDP',
  UNEP = 'UNEP',
  UNESCO = 'UNESCO',
  UNFCCC = 'UNFCCC',
  UNFPA = 'UNFPA',
  UNICEF = 'UNICEF',
  UNIDO = 'UNIDO',
  USAID = 'USAID',
  WFP = 'WFP',
  WMO = 'WMO',
  WB = 'World Bank',
}

export enum Recipient {
  MIN_INV_ENP_IND = 'Minister for Investment, Entrepreneurship and Industry',
  MIN_FORAFF_TOURISM = 'Minister of Foreign Affairs and Tourism',
  MIN_HEALTH = 'Ministry of Health',
  MIN_INTAFF = 'Ministry of Internal Affairs',
  MIN_TRANS = 'Ministry of Transport',
  MIN_LOCGOV_COMMAFF = 'Ministry for Local Government and Community Affairs',
  MIN_AGRI_CLIM_ENV = 'Ministry of Agriculture, Climate Change and Environment',
  MIN_EDU = 'Ministry of Education',
  MIN_EMP_SOAFF = 'Ministry of Employment and Social Affairs',
  MIN_FIN_ECOPLAN_TRD = 'Ministry of Finance, Economic Planning & Trade',
  MIN_FISH = 'Ministry of Fisheries',
  MIN_LAND_HOUSING = 'Ministry of Lands and Housing',
  MIN_YOUTH_SPO_FAM = 'Ministry of Youth, Sports and Family',
  OFF_PRESIDENT = 'Office of the President',
}

export enum EntityType {
  ACTION = 'action',
  PROGRAMME = 'programme',
  PROJECT = 'project',
  ACTIVITY = 'activity',
}

export enum GHGS {
  CO = 'CO2',
  COE = 'CO2e',
  CH = 'CH4',
  NO = 'N2O',
  HFC = 'HFCs',
  NF = 'NF3',
  PFC = 'PFCs',
  SF = 'SF6',
}

export enum SubSector {
  GRID_GENERAT = 'Grid-Connected Generation (electricity)',
  OFF_GRID_GENERAT = 'Off-Grid / Rural Generation (electricity)',
  TRANS_DISTR = 'Transmission & Distribution (electricity)',
  FUEL = 'Fuels',
  GOV = 'Government',
  INDUSTRY = 'Industry',
  APPLIANCES = 'Appliances',
  WATER = 'Water',
  CITIES = 'Cities',
  BUILDINGS = 'Buildings',
  LAND_TRANSPORT = 'Land (transport)',
  MARITIME_TRANSPORT = 'Maritime (transport)',
  AVIATION_TRANSPORT = 'Aviation (transport)',
  WASTE_WATER = 'Wastewater',
  WASTE_SOLID = 'Solid Waste',
  FORESTRY = 'Forestry',
  AGR_FORESTRY = 'Agroforestry',
  AGRICULTURE = 'Agriculture',
  LAND_USE = 'Land Use',
  COASTAL = 'Coastal',
  FISHING = 'Fishing',
  BIO_DIVERSITY = 'Biodiversity',
  ECO_SYS = 'Ecosystems',
  NATURE_BASED = 'Nature Based Solutions',
  TOURISM = 'Tourism',
  COMMERCIAL = 'Commercial',
  HOUSE_HOLDS = 'Households',
  FOOD_SYSTEMS = 'Food systems',
  MULTI_SUB_SEC = 'Multi-Subsector',
  NA = 'Not Applicable',
}

export enum TypeOfMitigation {
  AGRICULTURE = 'Agriculture',
  SOLAR = 'Solar',
  EE_HOUSEHOLDS = 'EEHouseholds',
}

export enum ExportFileType {
  XLSX = 'xlsx',
  CSV = 'csv',
}

export enum KPIAction {
  NONE = 'None',
  CREATED = 'Created',
  UPDATED = 'Updated',
}

export enum GHGRecordState {
  SAVED = 'SAVED',
  FINALIZED = 'FINALIZED',
}
